// Func = limiting Scope for this file


	$(document).ready(function () {
		//shortcodesBG();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		$('.booking-trigger').click(function(){
			$('.booking-widget').slideToggle();
			$(this).toggleClass('active');
			$('body').toggleClass('pause-scroll');

			if($(this).hasClass('active')) {
				$(this).html('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Close');
			} else {
				$(this).html('Book Now');
			}

			$('#content').click(function(e){
				e.preventDefault;
				$('.booking-widget').slideUp();
				$('.booking-trigger').removeClass('active').html('Book Now');
				$('body').removeClass('pause-scroll');
			});
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		};


		/* //disabled booking widget dates
		var startDate = "2023-10-30", 
		endDate  = "2024-04-26",  
		dateRange = [];

		var startDate2 = "2024-10-28", 
		endDate2  = "2024-11-01";

		// populate the array
		for (var d = new Date(startDate); d <= new Date(endDate); d.setDate(d.getDate() + 1)) {
			dateRange.push($.datepicker.formatDate('yy-mm-dd', d));
		};

		for (var d2 = new Date(startDate2); d2 <= new Date(endDate2); d2.setDate(d2.getDate() + 1)) {
			dateRange.push($.datepicker.formatDate('yy-mm-dd', d2));
		}; */

		if (BOOKING_DISABLED_DATES) {
			BOOKING_DISABLED_START_DATE = new Date(BOOKING_DISABLED_START_DATE).getTime();
			BOOKING_DISABLED_END_DATE = new Date(BOOKING_DISABLED_END_DATE).getTime();
		}
		
		if( ADITIONAL_BOOKING_DISABLED_START_DATE && ADITIONAL_BOOKING_DISABLED_END_DATE ){
			ADITIONAL_BOOKING_DISABLED_START_DATE = new Date(ADITIONAL_BOOKING_DISABLED_START_DATE).getTime();
			ADITIONAL_BOOKING_DISABLED_END_DATE = new Date(ADITIONAL_BOOKING_DISABLED_END_DATE).getTime();
		}

		console.log(BOOKING_START_DATE,);
		
		
		$( "#CheckIn" ).datepicker({
			changeMonth: true,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 1,
			altField:$('#altCheckIn'),
			altFormat:'yymmdd',
			minDate: BOOKING_START_DATE,
			maxDate: BOOKING_END_DATE,
			beforeShowDay: function (date) {
				if (BOOKING_DISABLED_DATES && ADITIONAL_BOOKING_DISABLED_START_DATE && ADITIONAL_BOOKING_DISABLED_END_DATE ) {
					return [(date.getTime() < BOOKING_DISABLED_START_DATE || date.getTime() > BOOKING_DISABLED_END_DATE) && (date.getTime() < ADITIONAL_BOOKING_DISABLED_START_DATE || date.getTime() > ADITIONAL_BOOKING_DISABLED_END_DATE)];
				}else if( ADITIONAL_BOOKING_DISABLED_START_DATE && ADITIONAL_BOOKING_DISABLED_END_DATE ){
					return [date.getTime() < ADITIONAL_BOOKING_DISABLED_START_DATE || date.getTime() > ADITIONAL_BOOKING_DISABLED_END_DATE];
				}else if( BOOKING_DISABLED_DATES ){
					return [date.getTime() < BOOKING_DISABLED_START_DATE || date.getTime() > BOOKING_DISABLED_END_DATE];
				}
				return [true];
			}
			/* minDate: "04/29/2022",
			maxDate: "10/31/2024",
			beforeShowDay: function (date) {
				var dateString = jQuery.datepicker.formatDate('yy-mm-dd', date);
				if( dateRange.indexOf(dateString) != -1 ){
					return [false, "dates_disabled"]
				}else{
					return [true, ""]
				}
			},
			onSelect: function(  ) {
				let getDate = $(this).datepicker('getDate');
				let range1 = new Date("28 October 2023 14:48 UTC");;
				let range2 = new Date("25 April 2024 14:48 UTC");;
				let range3 = new Date("26 October 2024 14:48 UTC");;
				let currentDate = new Date();

				if(getDate >= currentDate && getDate <= range1 ){
					$('.ratesOfDates').text("");
					$('.ratesOfDates').text("still bookable");
				}else if(getDate > range1 && getDate <= range2){
					$('.ratesOfDates').text("");
					$('.ratesOfDates').text("greyed out/not bookable");
				}else if(getDate > range2 && getDate <= range3){
					$('.ratesOfDates').text("");
					$('.ratesOfDates').text("bookable");
				}else{
					$('.ratesOfDates').text("");
				}
				console.log(dateRange);
			} */
		});


		// $( "#CheckIn" ).datepicker({
		// 	changeMonth: true,
		// 	dateFormat: 'mm/dd/yy',
		// 	numberOfMonths: 1,
		// 	altField:$('#altCheckIn'),
		// 	altFormat:'yymmdd',
		// 	minDate: "04/29/2022",
		// 	maxDate: "10/22/2022",
		// 	onSelect: function( selectedDate ) {
		// 		let getDate = $(this).datepicker('getDate');
		// 		let newDate = new Date(getDate.getTime());
		// 		newDate.setDate(newDate.getDate() + 3);
		// 		$( "#CheckOut" ).datepicker( "setDate", newDate );
		// 		$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		// 	} 
		// });

		$( "#CheckOut" ).datepicker({
			dateFormat: 'mm/dd/yy',
			changeMonth: true,
			altFormat:'yymmdd',
			altField:$('#altCheckOut'),
			numberOfMonths: 1,
			onSelect: function(  ) {}
		});

		const DATE_FORMAT = "mm/dd/yy";
		let opened = 0;
		let start = $('#checkInNewBW').val();
		let end = $('#checkOutNewBW').val();
		const firstDateAvaliable = $('#checkInNewBW').val();

		// console.log(start);
		// console.log(end);
		

		// $('#calendars_booking').datepicker({
		// 	showOn: "both",
		// 	changeMonth: true,
		// 	dateFormat: DATE_FORMAT,
		// 	numberOfMonths: 2,
		// 	monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
		// 	minDate: start,
		// 	beforeShowDay: function (date) {
		// 		let startDate = $.datepicker.parseDate(DATE_FORMAT, $('#checkInNewBW').val());
		// 		let endDate = $.datepicker.parseDate(DATE_FORMAT, $('#checkOutNewBW').val());

		// 		if (startDate) {
		// 			let maxDate = new Date(startDate);
		// 			maxDate.setDate(startDate.getDate() + 10);
					
		// 			if (date < startDate || date > maxDate) {
		// 				// return [true, "date-disabled"];
		// 				 return [false, ""];
		// 			}
		// 		}

		// 		if (date.getTime() == startDate.getTime()) {
		// 			return [true, "startday"];
		// 		} else if (date.getTime() == endDate.getTime()) {
		// 			return [true, "endday"];
		// 		} else if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
		// 			return [true, "days"];
		// 		} else {
		// 			return [true, ""];
		// 		}
		// 	},
		// 	onSelect: function (date) {
		// 		let arrive = $.datepicker.parseDate(DATE_FORMAT, $('#checkInNewBW').val());
		// 		let departure = $.datepicker.parseDate(DATE_FORMAT, $('#checkOutNewBW').val());
		// 		let selectedDate = $.datepicker.parseDate(DATE_FORMAT, date);

		// 		if (opened == 0) {
		// 			opened = 1;
		// 			start = date;
		// 			end = date;
		// 		} else {
		// 			opened = 0;
		// 			if (selectedDate <= arrive) {
		// 				end = start;
		// 				start = date;
		// 			} else {
		// 				end = date;
		// 			}
			
		// 		}

		// 		$('#checkInNewBW').attr("value", start);
		// 		$('#checkOutNewBW').attr("value", end);
				
		// 		let startDateJS = new Date(start),
		// 			endDateJS = new Date(end),
		// 			arrivalDate = document.querySelector(`#arrivalDate`),
		// 			nightsStay = document.querySelector(`#nightsStay`);

		// 		let startDateFormatedAsOB = {
		// 			day: startDateJS.getDate() < 10 ? '0'+startDateJS.getDate() : startDateJS.getDate(),
		// 			month: startDateJS.getMonth() + 1,
		// 			year: startDateJS.getFullYear()
		// 		};
		// 		// let endDateFormatedAsOB = {
		// 		// 	day: endDateJS.getDate() < 10 ? '0'+endDateJS.getDate() : endDateJS.getDate(),
		// 		// 	month: endDateJS.getMonth() + 1,
		// 		// 	year: endDateJS.getFullYear()
		// 		// };

		// 		let firstDateInMs = startDateJS.getTime();
		// 		let secondDateInMs = endDateJS.getTime();

		// 		let differenceBtwDates = secondDateInMs - firstDateInMs;
		// 		let aDayInMs = 24 * 60 * 60 * 1000;
		// 		let daysDiff = Math.round(differenceBtwDates / aDayInMs)
		// 		console.log(daysDiff);

		// 		arrivalDate.value = `${ startDateFormatedAsOB.year }${ startDateFormatedAsOB.month < 10 ? '0'+startDateFormatedAsOB.month : startDateFormatedAsOB.month }${ startDateFormatedAsOB.day }`;
		// 		nightsStay.value = `${daysDiff}`;
				
		// 	}
		// });
		
		
		
		
		$('#calendars_booking').datepicker({
			showOn: "both",
			changeMonth: false,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 2,
			monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			minDate: start, 
			maxDate: $( "#endBWlimit" ).val(),
			beforeShowDay: function (date) {
				let startDate = $.datepicker.parseDate(DATE_FORMAT, $('#checkInNewBW').val());
				let endDate = $.datepicker.parseDate(DATE_FORMAT, $('#checkOutNewBW').val());
		
				if (ADITIONAL_BOOKING_DISABLED_START_DATE && ADITIONAL_BOOKING_DISABLED_END_DATE && date.getTime() > ADITIONAL_BOOKING_DISABLED_START_DATE && date.getTime() < ADITIONAL_BOOKING_DISABLED_END_DATE) {
					return [false, "date-disabled", "date-disabled"];
				}

				if (startDate && !endDate) {
					let maxDate = new Date(startDate);
					maxDate.setDate(startDate.getDate() + 10); 
		
					if (date < startDate || date > maxDate) {
						return [false, "date-disabled"]; 
					} else {
						return [true, ""];
					}
				}			
		
				if (startDate && date.getTime() === startDate.getTime()) {
					return [true, "startday"];
				} else if (endDate && date.getTime() === endDate.getTime()) {
					return [true, "endday"]; 
				} else if (startDate && endDate && date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
					return [true, "days"]; 
				}
		
				return [true, ""]; 
			},
			onSelect: function (date) {
				let selectedDate = $.datepicker.parseDate(DATE_FORMAT, date);
				let startDate = $.datepicker.parseDate(DATE_FORMAT, $('#checkInNewBW').val());
				let endDate = $.datepicker.parseDate(DATE_FORMAT, $('#checkOutNewBW').val());

				// console.log($('#checkOutNewBW').val());
				
		
				if (!startDate || (startDate && endDate)) {
					$('#checkInNewBW').val(date);
					$('#checkOutNewBW').val("");
					start = selectedDate;
					end = null;
					//$('#calendars_booking').datepicker('option', 'minDate', null);
					//$('#calendars_booking').datepicker('option', 'maxDate', null);

					
				} else {
					end = selectedDate > startDate ? selectedDate : startDate;
					start = selectedDate > startDate ? startDate : selectedDate;
					$('#checkOutNewBW').val($.datepicker.formatDate(DATE_FORMAT, end));
		
					let maxDate = new Date(start);
					maxDate.setDate(start.getDate() + 10);

					//$('#calendars_booking').datepicker('option', 'minDate', firstDateAvaliable);
					//$('#calendars_booking').datepicker('option', 'maxDate', null);

					return [true, ""]; 
				}

				if (start && end) {
					let firstDateInMs = start.getTime();
					let secondDateInMs = end.getTime();
					let aDayInMs = 24 * 60 * 60 * 1000;
					let daysDiff = Math.round((secondDateInMs - firstDateInMs) / aDayInMs);
		
					let startDateFormatedAsOB = {
						day: start.getDate() < 10 ? '0' + start.getDate() : start.getDate(),
						month: start.getMonth() + 1,
						year: start.getFullYear()
					};
		
					let arrivalDate = document.querySelector(`#arrivalDate`);
					let nightsStay = document.querySelector(`#nightsStay`);
		
					if (arrivalDate && nightsStay) {
						arrivalDate.value = `${startDateFormatedAsOB.year}${startDateFormatedAsOB.month < 10 ? '0' + startDateFormatedAsOB.month : startDateFormatedAsOB.month}${startDateFormatedAsOB.day}`;
						nightsStay.value = `${daysDiff}`;
					}
				}
			}
		});

		$(".arrow-decrease").click(function () {
			var $qty = $(this).closest('.guests').find('.guest-qty');
			var currentVal = parseInt($qty.val());
			if (!isNaN(currentVal) && currentVal > 0) {
				$qty.val(currentVal - 1);
			}

			console.log(currentVal);
		});

		$(".arrow-increase").click(function () {
			var $qty = $(this).closest('.guests').find('.guest-qty');
			var currentVal = parseInt($qty.val());
			if (!isNaN(currentVal)) {
				$qty.val(currentVal + 1);
			}

			console.log(currentVal);
		});

		//SLIDER WITH BACKGROUND IMAGE DYNAMIC BULLET PLACEMENT
		var slider = $('.slider-quad--with-dots')
		.on('init', function(event,slick){
			var containerHeight = $('.slider-quad--with-dots .slider-quad__item').outerHeight();
			var copyHeight = $('.slider-quad--with-dots .slider-quad__item .slider-quad__copy').outerHeight();
			var bulletPosition = ((containerHeight - copyHeight) / 2 ) + 40;

			$('.slider-quad--with-dots .slick-dots').css('bottom', bulletPosition);
		})
		.slick({
			arrows: false, 
			autoplay: true, 
			autoplaySpeed: 5000,
			dots: true, 
			fade: true,
			pauseOnHover: false,
			speed: 700
		});

		slider.on('afterChange', function(event, slick, currentSlide){
			var containerHeight = $('.slider-quad--with-dots .slick-active .slider-quad__item').outerHeight();
			var copyHeight = $('.slider-quad--with-dots .slick-active .slider-quad__item .slider-quad__copy').outerHeight();
			var bulletPosition = ((containerHeight - copyHeight) / 2 ) + 40;

			$('.slider-quad--with-dots .slick-dots').css('bottom', bulletPosition);
		});


		//---Change layout menu  
	setTimeout(() => {
		if(document.querySelector('#default')){
			if(document.querySelector('#default').classList.contains('page-64109')) {
				let allMenuItems = document.querySelectorAll('.page-64109 .content-menus ul li');
				let activeLayout = document.querySelector('.page-64109 .content-menus ul li.lilac-lounge');
				let addClassLayout = document.getElementById('default');

				let changueInlilac = document.querySelector('.delay-1sec p span.hidden');
				let hiddenInlilac = document.querySelector('.delay-1sec p span.hidden-content');
				let initial_logo_url ="https://symphony.cdn.tambourine.com/mission-point-redesign/media/chianti-logo_w-tagline-67b365b9b7e40.webp";

				allMenuItems.forEach(item => {
					item.addEventListener('click', function () {
						if (item.classList.contains('lilac-lounge')) {
							addClassLayout.classList.add('lilac-lounge-layout');
							let changueBadgelilac = document.querySelector('.lilac-lounge-layout #intro');
							changueBadgelilac.setAttribute(
								'style',
								'background-image: url(https://symphony.cdn.tambourine.com/mission-point-redesign/media/lilac-lounge-67f81d3310620.png)'
							);
							if(changueInlilac){
								changueInlilac.classList.remove('hidden')
							}
							if(hiddenInlilac){
								hiddenInlilac.classList.add('hidden')	
							}

						} else {
							addClassLayout.classList.remove('lilac-lounge-layout');
							let changueBadgelilac = document.querySelector('#default.chianti.page-64109 #intro');
							changueBadgelilac.setAttribute(
								'style',
								`background-image: url(${initial_logo_url})`
							);


							if(hiddenInlilac){
								hiddenInlilac.classList.remove('hidden')	
							}
							if(changueInlilac){
								changueInlilac.classList.add('hidden')
							}

						}
					});
				});
				if (activeLayout) activeLayout.click();
			}
		}
	}, 1000);
		//---END Change layout menu  

	});

function shortcodesBG() {
	var shortcodeHeight = $('.shortcodes').outerHeight();

	console.log('Shortcodes Height = ' + shortcodeHeight);

	if(shortcodeHeight > 2500) {
		$('.shortcodes').addClass('shortcodes--multi-bgs');
	} else {
		$('.shortcodes').addClass('shortcodes--single-bg');
	}
}

document.addEventListener("DOMContentLoaded", function () {
    const menuTabs = document.querySelectorAll(".js-menu-tab");
    const openTableWidget = document.querySelector(".opentable-script");

    setTimeout(() => {
        menuTabs.forEach(tab => {
            tab.addEventListener("click", function () {
                const menuName = tab.getAttribute("data-menuname");

                if (menuName === "Lilac Lounge") {
                    openTableWidget.style.display = "none";
                } else {
                    openTableWidget.style.display = "block";
                }

                menuTabs.forEach(t => t.classList.remove("active"));
                tab.classList.add("active");
            });
        });
    }, 100); 
});